<template>
    <div>
      AnalyseView
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'AnalyseView',
  
    components: {
    },
  
    data() {
      return {
      }
    },
  
    methods: {
    }
  };
  </script>
  